<template>
  <FairHomeV2Page v-if="USE_FAIR_HOME_V2" />
  <FairHomePage v-else-if="USE_FAIR_HOME" />
  <HomeLayout v-else>
    <HomeWrapper />
  </HomeLayout>
</template>

<script setup lang="ts">
import HomeLayout from '@/components/layout/HomeLayout.vue'
import HomeWrapper from '@/widgets/home/HomeWrapper.vue'
import FairHomePage from '@/widgets/home/fair/FairHomePage.vue'
import { USE_FAIR_HOME } from '@/widgets/home/fair/fair-home.flags'
import { FairHomeV2Page, USE_FAIR_HOME_V2 } from '@/widgets/home/fair-v2'
</script>
